import { Link, useLocation } from 'react-router-dom';
import { MdSpaceDashboard, MdCategory, MdLocalGroceryStore, MdLayers, MdGroup, MdCoPresent, MdManageAccounts, MdOutlinePublicOff, MdGppGood } from "react-icons/md";
import { BiSolidOffer } from "react-icons/bi";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../redux/store';
import { useEffect, useState } from 'react';
import WebService from '../../Services/WebService';
import { setMenus } from '../../redux/slices/menuSlice';
import { ICON_MAP } from "../../utils/iconMapper";
import { MdOutlineKeyboardArrowRight } from "react-icons/md";
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';
import { setTierUpgradePendingCount, setTruckStopPendingCount, setRequestCallbackCount, setDriverPendingCount, setPendingRewardsFromTruckStopOwner, setReviewFlagCount } from '../../redux/slices/trainingSlice';

const VerticalMenu = () => {
    const dispatch = useDispatch();
    const menus = useSelector((state: RootState) => state.menus.items);
    const truckStopPendingCount = useSelector((state: RootState) => state.training.truck_stop_pending_count);
    const tierUpgradePendingCount = useSelector((state: RootState) => state.training.tier_upgrade_pending_count);
    const driverPendingCount = useSelector((state: RootState) => state.training.driver_pending_count);
    const pendingRewardsFromTruckStopOwner = useSelector((state: RootState) => state.training.pending_rewards_from_truck_stop_owner);
    const reviewFlagPendingCount = useSelector((state: RootState) => state.training.review_flag_pending_count);
    const requestCallbackCount = useSelector((state: RootState) => state.training.requestcallback_count);
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState<string | null>(null);
    const [callbackCount, setCallbackCount] = useState<number>(0);
    const [truckStopCount, setTruckStopCount] = useState<number>(0);
    const [driverCount, setDriverCount] = useState<number>(0);
    const [tierCount, setTierCount] = useState<number>(0);
    const [rewardCount, setRewardCount] = useState<number>(0);
    const [reviewCount, setReviewCount] = useState<number>(0);

    useEffect(() => {
        WebService.getAPI({
            action: "profile/my-menus",
            isShowError: true
        }).then((res: any) => {
            if (res?.status) {
                dispatch(setMenus(res?.data));
                dispatch(setRequestCallbackCount(res?.requestcallback_count || 0));
                dispatch(setTruckStopPendingCount(res?.truck_stop_pending_count || 0));
                dispatch(setDriverPendingCount(res?.driver_pending_count || 0));
                dispatch(setTierUpgradePendingCount(res?.tier_upgrade_pending_count || 0));
                dispatch(setPendingRewardsFromTruckStopOwner(res?.pending_rewards_from_truck_stop_owner || 0));
                dispatch(setReviewFlagCount(res?.review_flag_pending_count || 0));
            }
            const count = Number(res?.requestcallback_count || 0);
            const truckStop = Number(res?.truck_stop_pending_count || 0);
            const driver = Number(res?.driver_pending_count || 0);
            const tier = Number(res?.tier_upgrade_pending_count || 0);
            const reward = Number(res?.pending_rewards_from_truck_stop_owner || 0);
            const review = Number(res?.review_flag_pending_count || 0);
            localStorage.setItem("requestcallback_count", String(count));
            localStorage.setItem("truckstop_count", String(truckStop));
            localStorage.setItem("driver_count", String(driver));
            localStorage.setItem("tier_count", String(tier));
            localStorage.setItem("reward_count", String(reward));
            localStorage.setItem("review_count", String(review));
            setTruckStopCount(truckStop);
            setDriverCount(driver);
            setTierCount(tier);
            setCallbackCount(count);
            setRewardCount(reward);
            setReviewCount(review);
        });

        const stored = Number(localStorage.getItem("requestcallback_count") || 0);
        setCallbackCount(stored);
        const storedTruckStop = Number(localStorage.getItem("truckstop_count") || 0);
        setTruckStopCount(storedTruckStop);
        const storedDriver = Number(localStorage.getItem("driver_count") || 0);
        setDriverCount(storedDriver);
        const storedTier = Number(localStorage.getItem("tier_count") || 0);
        setTierCount(storedTier);
        const storedReward = Number(localStorage.getItem("reward_count") || 0);
        setRewardCount(storedReward);
        const storedReview = Number(localStorage.getItem("review_count") || 0);
        setReviewCount(storedReview);
    }, []);

    const toggleMenu = (menuId: string) => {
        setOpenMenu(prev => (prev === menuId ? null : menuId));
    };

    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <>
            <div id="vertical_menu" className="verticle-menu">
                <SimpleBar style={{ maxHeight: 'calc(100vh - 100px)', overflowX: 'hidden' }}>
                    <div className="menu-list">
                        {menus.filter((menu: any) => menu.can_read === 1)
                            .map((menu: any) => {
                                const Icon = ICON_MAP[menu.icon] || ICON_MAP["default"];
                                const isActive = location.pathname === menu.url;
                                const isParentActive =
                                    menu.subMenus?.some(
                                        (sub: any) => location.pathname === sub.url
                                    );

                                // ✅ MENU WITHOUT SUBMENUS
                                if (!menu.subMenus || menu.subMenus.length === 0) {
                                    return (
                                        <Link
                                            key={menu.menu_id}
                                            to={menu.url}
                                            className={`menu-item ${location.pathname === menu.url ? "active" : ""
                                                }`}
                                        >
                                            <Icon size={20} className="menu-icon" />
                                            <span>{menu.title}</span>
                                            {menu?.url === "/request-callback" && callbackCount > 0 && (
                                                <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                    {requestCallbackCount || callbackCount}
                                                </span>
                                            )}
                                            {menu?.url === "/truck-stop-owner" && truckStopCount > 0 && (
                                                <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                    {truckStopPendingCount || truckStopCount}
                                                </span>
                                            )}
                                            {menu?.url === "/driver" && driverCount > 0 && (
                                                <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                    {driverPendingCount || driverCount}
                                                </span>
                                            )}
                                            {menu?.url === "/tier-upgrade-request" && tierCount > 0 && (
                                                <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                    {tierUpgradePendingCount || tierCount}
                                                </span>
                                            )}
                                            {menu?.url === "/reward" && rewardCount > 0 && (
                                                <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                    {pendingRewardsFromTruckStopOwner || rewardCount}
                                                </span>
                                            )}
                                            {menu?.url === "/review-feedback" && reviewCount > 0 && (
                                                <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                    {reviewFlagPendingCount || reviewCount}
                                                </span>
                                            )}
                                        </Link>
                                    );
                                }

                                // ✅ MENU WITH SUBMENUS
                                return (
                                    <div key={menu.menu_id} className="menu-group">
                                        <div style={{ cursor: 'pointer' }}
                                            className={`menu-item parent ${isParentActive ? "active" : ""
                                                }`}
                                            onClick={() => toggleMenu(menu.menu_id)}
                                        >
                                            <Icon size={20} className="menu-icon" />
                                            <span>{menu.title}</span>
                                            <span className="arrow">
                                                {openMenu === menu.menu_id ? "▾" : "▸"}
                                            </span>
                                        </div>

                                        {openMenu === menu.menu_id && (
                                            <div className="submenu-list ss">
                                                {menu.subMenus
                                                    .filter((sub: any) => sub.can_read === 1)
                                                    .map((sub: any) => {
                                                        const SubIcon = ICON_MAP[sub.icon] || MdOutlineKeyboardArrowRight;

                                                        return (
                                                            <Link
                                                                key={sub.menu_id}
                                                                to={sub.url}
                                                                className={`submenu-item ${location.pathname === sub.url ? "active" : ""
                                                                    }`}
                                                            >
                                                                <div className="flex items-center gap-2">
                                                                    {/* arrow */}
                                                                    <MdOutlineKeyboardArrowRight size={14} className="text-gray-400" />

                                                                    {/* submenu icon */}
                                                                    <SubIcon size={16} className="submenu-icon" />

                                                                    {/* title */}
                                                                    <span>{sub.title}</span>

                                                                    {sub?.url === "/request-callback" && callbackCount > 0 && (
                                                                        <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                                            {callbackCount}
                                                                        </span>
                                                                    )}
                                                                    {sub?.url === "/truck-stop-owner" && truckStopCount > 0 && (
                                                                        <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                                            {truckStopPendingCount || truckStopCount}
                                                                        </span>
                                                                    )}
                                                                    {sub?.url === "/driver" && driverCount > 0 && (
                                                                        <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                                            {driverCount}
                                                                        </span>
                                                                    )}
                                                                    {sub?.url === "/tier-upgrade-request" && tierCount > 0 && (
                                                                        <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                                            {tierUpgradePendingCount || tierCount}
                                                                        </span>
                                                                    )}
                                                                    {sub?.url === "/reward" && rewardCount > 0 && (
                                                                        <span className="ml-2 bg-red-500 text-white text-xs px-2 py-[2px] rounded-full">
                                                                            {rewardCount}
                                                                        </span>
                                                                    )}
                                                                </div>
                                                            </Link>
                                                        );
                                                    })}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                    </div>
                </SimpleBar>
            </div>
        </>
    )
}
export default VerticalMenu;